import { useEffect, useState } from 'react'
import { AdminPage } from '@/pages/AdminPage'
import { LandingPage } from '@/pages/LandingPage'
import { RoomPage } from '@/pages/RoomPage'
import { useRoomSession } from '@/hooks/useRoomSession'
import { loadNickname, loadLastRoomCode, roomCodeFromLocation } from '@/lib/format'

/** Rota do painel do operador. O unico link pra ca so aparece pra quem tem o cargo. */
const ADMIN_PATH = '/admin'

export function App() {
    const session = useRoomSession()
    const [currentLocationCode, setCurrentLocationCode] = useState(() => (typeof window === 'undefined'
        ? ''
        : roomCodeFromLocation(window.location.pathname, window.location.search)))

    // Acompanha navegação do botão Voltar / Avançar do navegador
    useEffect(() => {
        if (typeof window === 'undefined') return
        const onPopState = () => {
            const code = roomCodeFromLocation(window.location.pathname, window.location.search)
            setCurrentLocationCode(code)
        }
        window.addEventListener('popstate', onPopState)
        return () => window.removeEventListener('popstate', onPopState)
    }, [])

    // A URL segue a sala: /sala/XXXX-XXXX enquanto dentro.
    useEffect(() => {
        if (typeof window === 'undefined') return
        if (session.room) {
            const path = `/sala/${session.room.code}`
            if (window.location.pathname !== path) window.history.replaceState(null, '', path)
        }
    }, [session.room])

    // Antes de qualquer coisa da sala: o painel e uma tela a parte, e quem entra
    // nele nao esta participando de sala nenhuma.
    if (typeof window !== 'undefined' && window.location.pathname.replace(/\/$/, '') === ADMIN_PATH) {
        return <AdminPage />
    }

    if (session.room) return <RoomPage session={session} room={session.room} />

    const initialCode = currentLocationCode || loadLastRoomCode()

    return (
        <LandingPage
            brand={session.config.brand}
            status={session.status}
            error={session.error}
            initialNickname={loadNickname()}
            initialCode={initialCode}
            avatar={session.avatar}
            onAvatarChange={session.setAvatar}
            onCreate={session.createRoom}
            onJoin={session.joinRoom}
        />
    )
}
